module.exports = __webpack_public_path__ + "static/media/rnaapp_113.68c4b5bb.ico";